import { render, staticRenderFns } from "./DevlopmentWarehouse.vue?vue&type=template&id=b6039e5c&scoped=true&"
import script from "./DevlopmentWarehouse.vue?vue&type=script&lang=js&"
export * from "./DevlopmentWarehouse.vue?vue&type=script&lang=js&"
import style0 from "./DevlopmentWarehouse.vue?vue&type=style&index=0&id=b6039e5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6039e5c",
  null
  
)

export default component.exports